import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ShareViaWizardSteps } from '../../constants';
import { useShareViaSettings } from '../ShareViaSettingsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SharingMethodStepFooter = () => {
  const {
    stepIndex,
    selectedApp,
    setStepIndex
  } = useShareViaSettings();
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    children: [/*#__PURE__*/_jsx(Button, {
      use: "primary",
      disabled: stepIndex === ShareViaWizardSteps.sharingMethodStep,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.shareVia.dialog.controls.backButton"
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: () => setStepIndex(ShareViaWizardSteps.configurationStep),
      use: "primary",
      disabled: !selectedApp,
      "data-test-id": "share-report-dialog-next-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.shareVia.dialog.controls.nextButton"
      })
    })]
  });
};
export default SharingMethodStepFooter;